<template>
  <div class="top-frame">
    <!-- pc端 -->
    <div class="st-top">
      <img
        class="st-logo"
        :src="URL + setInfo.logoImgUrl"
        @click="$route.path !== '/' && $router.push('/')"
        alt=""
      />
      <div class="st-nav">
        <ul class="st-ul">
          <li
            :class="{ activeli: $route.path === item.path, navLi: true }"
            v-for="item in $store.state.navList"
            :key="item.id"
            @click="changeNav(item)"
          >
            <span class="nav-title">{{ item.name }}</span>
            <ul class="nav-sub">
              <li
                v-for="child in item.children"
                :key="child.id"
                @click.stop="changeNav(item, child)"
              >
                {{ child.name }}
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div class="right">
        <div class="search-box">
          <input
            type="text"
            placeholder="搜索相关产品..."
            v-model="searchData"
            @keyup.enter="searchPro"
          />
          <img src="../assets/search.png" alt="" @click="searchPro" />
        </div>

        <div class="out-link">
          <img
            v-for="item in friendList"
            :key="item.id"
            :src="URL + item.friendImage"
            :title="item.name"
            alt=""
            @click="push(item)"
          />
        </div>
      </div>
    </div>
    <!-- 手机端 -->
    <div class="m-st-top">
      <van-nav-bar fixed>
        <template #left>
          <van-icon name="wap-nav" size="22" @click.stop="openShow" />
        </template>
        <template #right>
          <van-icon name="search" size="22" @click="openSearch = true" />
        </template>
        <template #title>
          <div class="center">
            <img
              class="st-logo"
              :src="URL + setInfo.logoImgUrl"
              @click="$route.path !== '/' && $router.push('/')"
              alt=""
            />
            <div class="out-link">
              <img
                v-for="item in friendList"
                :key="item.id"
                :src="URL + item.friendImage"
                :title="item.name"
                alt=""
                @click="push(item)"
              />
            </div>
          </div>
        </template>
      </van-nav-bar>
      <div :class="['m-st-fixeddiv', openSearch ? 'openSearch' : '']">
        <van-search
          class="m-st-top-search"
          show-action
          clearable
          v-model="searchData"
          placeholder="搜索你想要的产品"
        >
          <template #action>
            <div @click="onSearch">{{ searchData ? "搜索" : "取消" }}</div>
          </template>
        </van-search>
      </div>
    </div>
  </div>
</template>
<script>
import { searchwebConfig } from "@/util/set/set";
import { sysFriendLinkList } from "../util/friendlink/friendlink";
import { URL } from "@/util/config";
export default {
  inject: ["reload"],
  data() {
    return {
      URL,
      activeId: this.$route.path,
      show: false,
      openSearch: false,
      searchData: "",
      name: localStorage.getItem("name"),
      setInfo: {},
      friendList: [],
    };
  },
  watch: {
    $store(newer) {
      console.log(newer);
    },
  },
  created() {
    //配置信息
    searchwebConfig().then((res) => {
      if (res.code === 0) {
        this.setInfo = res.data;
      }
    });

    // linkFlag == 0 ? 主页友情链接 : 头部跳转链接
    sysFriendLinkList({ linkFlag: 1 }).then((res) => {
      this.friendList = res.data;
    });
  },
  mounted() {},
  methods: {
    openShow() {
      this.$emit("openShow");
    },
    changeNav(val, child) {
      // console.log(JSON.parse(JSON.stringify(val)));
      this.$store.commit("SET_INFO", { code: val.code, name: val.name });
      this.$store.commit("SET_SUBLIST", { subList: val.children });
      window.scrollTo(0, 0);
      if (val.routeName == "/product") {
        localStorage.removeItem("activeCode");
      }
      // 路由跳转
      if (child !== undefined) {
        sessionStorage.setItem("childCode", child.code);

        if (val.routeName == this.$route.path) {
          this.reload();
        } else {
          this.$router.push(val.routeName);
        }
      } else {
        sessionStorage.removeItem("childCode");
        if (val.routeName !== this.$route.path) {
          this.$router.push(val.routeName);
        } else {
          this.reload();
        }
      }

      this.searchData = "";
    },
    onSearch() {
      if (this.searchData) {
        this.searchPro();
      } else {
        this.openSearch = false;
      }
    },
    searchPro() {
      if (!this.searchData) {
        return;
      }
      sessionStorage.setItem("key", this.searchData);
      localStorage.removeItem("activeCode");
      this.searchData = "";
      this.openSearch = false;
      if (this.$route.path == "/product") {
        this.reload();
      } else {
        this.$router.push("/product");
      }
    },
    push(item) {
      window.open(item.hrefUrl);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../style/color.scss";
@function pxToRem($args) {
  @return $args / 50 + rem;
}

.top-frame {
  user-select: none;
}
.st-top {
  background-color: $white;
  width: 1200px;
  height: 90px;
  margin: 0 auto;
  display: flex;
  align-items: center;

  .st-logo {
    &:hover {
      cursor: pointer;
    }
  }
}

.st-nav {
  margin-left: 10px;
  height: 50px;
  .st-ul {
    font-size: 16px;
    line-height: 50px;
    display: flex;
    .navLi {
      width: 100px;
      text-align: center;
      transition: all 0.3s;
      position: relative;
      z-index: 11;

      &:hover {
        cursor: pointer;
        border-width: 2px;

        &::after {
          width: 100px;
        }
        .nav-title {
          color: $theme;
        }

        .nav-sub {
          max-height: 500px;
          margin-top: 10px;
        }
      }
      &::after {
        content: "";
        display: block;
        position: absolute;
        bottom: 0;
        left: 0;
        width: 0;
        height: 2px;
        background-color: $theme;
        transition: all 0.2s;
      }

      .nav-sub {
        max-height: 0px;
        font-size: 14px;
        line-height: 40px;
        transition: all 0.1s linear;
        background-color: #ffffff;
        position: absolute;
        top: 42px;
        overflow: hidden;
        box-shadow: 1px 3px 5px rgb(216, 216, 216);

        li {
          width: 100px;
          white-space: nowrap;
          transition: all 0.2s;
          &:hover {
            color: $theme;
            background-color: rgb(243, 243, 243);
          }
        }
      }
    }
    .activeli {
      color: $theme;
    }
  }
}
.right {
  width: 290px;
  height: 100%;
  margin-left: 10px;
  position: relative;

  .search-box {
    width: 145px;
    height: 100%;
    position: relative;
    z-index: 10;
    transition: width 0.5s;
    display: flex;
    align-items: center;
    background-color: #fff;

    &:hover {
      width: 100%;
    }

    input {
      width: 100%;
      outline: none;
      font-size: 14px;
      padding: 6px 28px 5px 15px;
      box-sizing: border-box;
      border-radius: 32px;
      background: #fff;
      color: #9e9c9c;
      border: 1px #d7d4d4 solid;
    }
    img {
      width: 20px;
      position: absolute;
      right: 7px;
      top: 50%;
      transform: translateY(-50%);
      &:hover {
        cursor: pointer;
      }
    }
  }

  .out-link {
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    z-index: 0;

    img:hover {
      cursor: pointer;
    }
  }
}
.m-st-top {
  display: none;
}
@media (max-width: 1300px) {
  .st-top {
    width: 1100px;
  }
  .st-nav .st-ul .navLi {
    width: 80px;

    &:hover::after {
      width: 80px;
    }

    .nav-sub li {
      width: 80px;
      font-size: 10px;
    }
  }
}
@media (max-width: 1024px) {
  .top-frame {
    margin-bottom: 1.2rem;
  }
  .st-nav {
    display: none;
  }
  .st-top {
    display: none;
  }
  .m-st-top {
    display: block;
    width: 100%;
    .m-st-fixeddiv {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      padding: 0 10px;
      box-sizing: border-box;
      z-index: 101;
      opacity: 0;
      pointer-events: none;
      transition: all 0.3s;
      .m-st-top-search {
        width: 100%;
        .van-search__content {
          border-radius: 20px;
        }
        // .van-search__action {
        //   width: 10%;
        // }
      }
      span {
        display: inline-block;
        font-size: 15px;
        line-height: 30px;
        padding: 0 4px;
        &:active {
          background-color: rgba(51, 51, 51, 0.5);
        }
      }
    }
    .openSearch {
      opacity: 1;
      pointer-events: visible;
    }

    .center {
      width: pxToRem(240);
      display: flex;
      justify-content: space-between;
      align-items: center;

      .st-logo {
        width: pxToRem(120);
        height: pxToRem(20);
      }
      .out-link {
        height: pxToRem(60);

        img {
          width: pxToRem(40);
          vertical-align: middle;
        }
      }
    }

    ul {
      list-style: none;
      font-size: 16px;
      line-height: 50px;
      color: $white;
      li {
        width: 100%;
        text-align: center;
        float: left;
        cursor: pointer;
        &:hover {
          background-color: #2b74e2;
        }
      }
      .activeli {
        background-color: #2b74e2;
      }
    }
  }
}
</style>
